var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAboutpgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#9F73E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 38.6667C34 38.6667 40 34.0001 40 27.5556C40 22.6667 36.6667 18.6667 32 18.6667C27.3333 18.6667 24 22.6667 24 27.5556C24 34.0001 30 38.6667 32 38.6667Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9999 27.3333C32.3681 27.3333 32.6666 27.0349 32.6666 26.6667C32.6666 26.2985 32.3681 26 31.9999 26C31.6317 26 31.3333 26.2985 31.3333 26.6667C31.3333 27.0349 31.6317 27.3333 31.9999 27.3333Z",
    fill: "white",
    stroke: "#9F73E6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 40C22.086 40.5513 21.3333 41.2484 21.3333 41.9455C21.3333 43.8653 26.1333 45.3333 31.9999 45.3333C37.8666 45.3333 42.6666 43.8653 42.6666 41.9455C42.6666 41.2484 41.9139 40.5513 40.6666 40",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutpgLocation);
export default __webpack_public_path__ + "static/media/aboutpg_location.529d737714a678c1429cfe8492f53e4c.svg";
export { ForwardRef as ReactComponent };